<section>
  <div class="d-flex flex-column h-100" id="uploadSkuCsvMainDiv">
    <div class="upload_csv_header" id="uploadCsvHeader">
      <div class="d-flex align-items-center" id="uploadCsvHeader">
        <img class="upload_csv_icon" alt="Upload CSV icon" />
        <span i18n="@@upload-sku-csv.heading.upload-via-csv">Upload via CSV</span>
      </div>
    </div>
    <div class="pt-4" id="dwnldCsvTemplate">
      <span class="download" i18n="@@upload-sku-csv.link.dwnld-csv-template"><strong>1.</strong>&nbsp;<a (click)="downloadTemplate()" [download]="downloadFile" class="download_csv_link">Download CSV Template</a></span>
      <div class="csv-upload-div" id="csvUploadDiv">
        <span i18n="@@upload-sku-csv.msg.fill-csv-template"><strong>2.</strong> Fill the CSV template with the SKU details that you would like to create or edit.</span>
      </div>
      <!-- PROCESSOR LIST DIV -->
      <div class="processor_list" id="processorList">
        <span i18n="@@upload-sku-csv.desc.processor-name-rule"><strong>3.</strong> Copy processor details from the list below and make sure they match exactly.</span>
        <div class="mt-2 processor-list-main-div" id="processorListDiv">
          <div class="table_collapse_link collapsed processor-list-div" data-toggle="collapse"
            [attr.aria-expanded]="isProcessorListExpanded" aria-controls="collapseProcList" id="tblCollapseLink">
            <span i18n="@@upload-sku-csv.label.processor-list">Processors</span>
            <div class="expand-arrow-custom" (click)="getProcessorList()" id="expndArrowCustom">
              <img class="table_row_expanded processor-list-arrow" alt="expand"
                [ngClass]="isProcessorListExpanded?'transform-180':''" />
            </div>
          </div>
          <div class="collapse processor-list-section-div" id="collapseProcList" data-parent="#processorListDiv"
            #collapse="ngbCollapse" [(ngbCollapse)]="!isProcessorListExpanded" aria-labelledby="processorListSection">
            <div class="card-body" id="collapseProcListCardBody">
              <div class="row" id="collapseProcListRow">
                <div class="col" id="collapseProcListCol">
                  <div class="pt-1 alphabetical_list" *ngFor="let proc of processorListColumnOne;" id="collapseProcListColumnOne">
                    <div *ngFor="let item of proc.name;" id="collapseProcName">
                      <div id="collapseProcItem">{{item}}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- OS LIST DIV -->
      <div class="mt-2 os_list" id="osList">
        <span i18n="@@upload-sku-csv.desc.os-name-rule"><strong>4.</strong> Copy Operating System details from the below list and make sure they match exactly.</span>
        <div class="mt-2 os-list-main-div" id="osListDiv">
          <div class="table_collapse_link collapsed os-list-div" data-toggle="collapse"
            [attr.aria-expanded]="isOSListExpanded" aria-controls="collapseOSList" id="tblOSCollapseLink">
            <span i18n="@@upload-sku-csv.label.os-name-list">Operating System</span>
            <div class="expand-arrow-custom" (click)="getOSList()" id="expndArrowCustom">
              <img class="table_row_expanded os-list-arrow" alt="expand"
                [ngClass]="isOSListExpanded?'transform-180':''" />
            </div>
          </div>
        </div>
        <div class="collapse os-list-section-div" id="collapseOSList" data-parent="#osListDiv"
            #collapse="ngbCollapse" [(ngbCollapse)]="!isOSListExpanded" aria-labelledby="osListSection">
            <div class="card-body" id="collapseOSListCardBody">
              <div class="row" id="collapseOSListRow">
                <div class="col" id="collapseOSListCol">
                  <div class="pt-1" *ngFor="let osItem of osListColumn;" id="collapseOSListColumnOne">
                    <div id="collapseOSItem">{{osItem.name}}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
      </div>
       <!-- GRAPHICS LIST DIV -->
       <div class="mt-2 graphics_list" id="graphicsList">
        <span i18n="@@upload-sku-csv.desc.graphics-name-rule"><strong>5.</strong> Below is a list of graphic card choices. You can copy the details from the list or type in your own.</span>
        <div class="mt-2 graphics-list-main-div" id="graphicsListDiv">
          <div class="table_collapse_link collapsed graphics-list-div" data-toggle="collapse"
            [attr.aria-expanded]="isGraphicsListExpanded" aria-controls="collapseGraphicsList" id="tblGraphicsCollapseLink">
            <span i18n="@@upload-sku-csv.label.graphics-name-list">Graphics</span>
            <div class="expand-arrow-custom" (click)="getGraphicsList()" id="expndArrowCustom">
              <img class="table_row_expanded graphics-list-arrow" alt="expand"
                [ngClass]="isGraphicsListExpanded?'transform-180':''" />
            </div>
          </div>
        </div>
        <div class="collapse graphics-list-section-div" id="collapseGraphicsList" data-parent="#graphicsListDiv"
            #collapse="ngbCollapse" [(ngbCollapse)]="!isGraphicsListExpanded" aria-labelledby="graphicsListSection">
            <div class="card-body" id="collapseGraphicsListCardBody">
              <div class="row" id="collapseGraphicsListRow">
                <div class="col" id="collapseGraphicsListCol">
                  <div class="pt-1" *ngFor="let graphicsItem of graphicsListColumn;" id="collapseGraphicsListColumnOne">
                    <div id="collapseGraphicsItem"  [innerHTML]="graphicsItem.name"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
      </div>
      <div class="upload-submit-txt" id="uploadSubmitTxt">
        <span i18n="@@upload-sku-csv.desc.upload-and-submit"><strong>6.</strong> Upload and submit the completed
          template</span>:
      </div>
      <div class="ml-3" id="uploadCSVNote">{{uploadCSVNote}}</div>
      <label class="upload-margin">
        <input #csvInput type="file" id="file-picker" accept=".csv" (change)="onFilechange($event)" hidden />
        <span class="btn btn-primary left_icon_btn gtmSkuUpload">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M7.33071 9.30042L5.88471 9.05292C5.37346 8.96647 4.84984 8.98699 4.34692 9.11317C3.844 9.23935 3.37271 9.46845 2.96282 9.78601C2.55294 10.1036 2.21336 10.5027 1.96554 10.9581C1.71772 11.4136 1.56704 11.9155 1.52302 12.4321C1.47901 12.9487 1.54261 13.4689 1.70981 13.9597C1.87702 14.4505 2.14419 14.9013 2.49445 15.2836C2.84471 15.6659 3.27045 15.9715 3.74477 16.1809C4.2191 16.3903 4.73171 16.4991 5.25021 16.5004H9.00021V18.0004H5.25021C4.52341 18.0003 3.80454 17.8493 3.13913 17.5569C2.47372 17.2646 1.87626 16.8372 1.38459 16.302C0.892912 15.7667 0.517733 15.1352 0.282804 14.4474C0.0478744 13.7596 -0.0416861 13.0305 0.0197929 12.3063C0.0812719 11.5821 0.292451 10.8786 0.639959 10.2402C0.987466 9.6019 1.46373 9.04266 2.0386 8.59794C2.61347 8.15322 3.27441 7.83271 3.97958 7.6567C4.68475 7.48069 5.41879 7.45301 6.13521 7.57542C6.31291 6.59325 6.68479 5.6564 7.22908 4.81974C7.77336 3.98309 8.47911 3.26343 9.30499 2.70293C10.1309 2.14243 11.0603 1.75235 12.0388 1.55553C13.0173 1.3587 14.0253 1.3591 15.0037 1.55669C15.982 1.75428 16.9111 2.14509 17.7366 2.70624C18.562 3.26739 19.2672 3.98759 19.8108 4.82468C20.3545 5.66176 20.7256 6.5989 20.9025 7.58121C21.0795 8.56353 21.0586 9.57127 20.8412 10.5454C21.7716 10.6957 22.6113 11.1906 23.1934 11.9317C23.7755 12.6729 24.0573 13.6059 23.9828 14.5454C23.9083 15.4849 23.483 16.3619 22.7914 17.002C22.0998 17.6422 21.1926 17.9986 20.2502 18.0004H15.0002V16.5004H20.2502C20.8158 16.5001 21.3606 16.2867 21.7759 15.9028C22.1913 15.5188 22.4468 14.9926 22.4917 14.4287C22.5365 13.8649 22.3673 13.3049 22.0178 12.8602C21.6683 12.4154 21.1642 12.1187 20.6057 12.0289L19.0502 11.7814L19.3742 10.2394C19.5305 9.46696 19.5331 8.67127 19.3819 7.89778C19.2307 7.1243 18.9287 6.38817 18.493 5.73143C18.0573 5.07469 17.4965 4.51019 16.8427 4.07017C16.1888 3.63015 15.4547 3.32323 14.6822 3.16692C13.9097 3.01062 13.1141 3.00799 12.3406 3.15919C11.5671 3.3104 10.831 3.61247 10.1742 4.04816C9.51748 4.48385 8.95298 5.04463 8.51296 5.69849C8.07294 6.35234 7.76602 7.08646 7.60971 7.85892L7.33221 9.29892L7.33071 9.30042Z" />
            <path fill-rule="evenodd" clip-rule="evenodd"
              d="M7.49964 13.2806C7.64028 13.4212 7.83101 13.5002 8.02989 13.5002C8.22876 13.5002 8.41949 13.4212 8.56014 13.2806L11.9996 9.83964L15.4391 13.2791C15.5083 13.3508 15.5911 13.4079 15.6826 13.4472C15.7741 13.4865 15.8725 13.5072 15.9721 13.5081C16.0717 13.5089 16.1704 13.49 16.2626 13.4523C16.3548 13.4145 16.4385 13.3589 16.5089 13.2884C16.5794 13.218 16.635 13.1343 16.6728 13.0421C16.7105 12.9499 16.7294 12.8512 16.7286 12.7516C16.7277 12.652 16.707 12.5536 16.6677 12.4621C16.6284 12.3706 16.5713 12.2878 16.4996 12.2186L12.5306 8.24964C12.461 8.17979 12.3782 8.12438 12.2871 8.08657C12.196 8.04876 12.0983 8.0293 11.9996 8.0293C11.901 8.0293 11.8033 8.04876 11.7122 8.08657C11.6211 8.12438 11.5383 8.17979 11.4686 8.24964L7.49964 12.2186C7.42979 12.2883 7.37438 12.3711 7.33657 12.4622C7.29876 12.5533 7.2793 12.651 7.2793 12.7496C7.2793 12.8483 7.29876 12.946 7.33657 13.0371C7.37438 13.1282 7.42979 13.211 7.49964 13.2806Z" />
            <path fill-rule="evenodd" clip-rule="evenodd"
              d="M12 9C12.1989 9 12.3897 9.07902 12.5303 9.21967C12.671 9.36032 12.75 9.55109 12.75 9.75V21.75C12.75 21.9489 12.671 22.1397 12.5303 22.2803C12.3897 22.421 12.1989 22.5 12 22.5C11.8011 22.5 11.6103 22.421 11.4697 22.2803C11.329 22.1397 11.25 21.9489 11.25 21.75V9.75C11.25 9.55109 11.329 9.36032 11.4697 9.21967C11.6103 9.07902 11.8011 9 12 9Z" />
          </svg><span i18n="@@settings.cp-settings-body.upload-csv">Upload CSV</span>
        </span>
      </label>
      <div class="error-margin" *ngIf="skuFileName && !fileName" id="skuFileName">
        {{skuFileName}}</div>
      <div class="error-margin" *ngIf="skuValidationError" title="{{ fileName }}" id="fileName">{{fileName}}</div>
      <!-- IJR-2399 start -->
      <ul class="tooltip-list-style">
        <li *ngIf="showcsvError">
          <div class="text-danger" id="FileMustBeCSVFormat"><span i18n="@@settings.sku-upload.csv-format-error">File must be in CSV format</span>
          </div>
        </li>
        <li *ngIf="csvTemplateError && !showcsvError">
          <div class="text-danger" id="uploadCSVErr">{{uploadedCSVError}}</div>
        </li>
        <li
          *ngIf="((dasTeteDecimalPointChecker > 0) || (dasTroncDecimalPointChecker > 0) || (dasMembreDecimalPointChecker > 0)) && !showcsvError && !csvTemplateError">
          <div class="text-danger" id="dsaDecimalPtValidationMsg">
            <span>{{dasDecimalPointValidationMsg}}</span>
          </div>
        </li>
        <li *ngIf="isSkuCodeAvailableError && !showcsvError && !csvTemplateError">
          <div class="text-danger" is="skuCodeMissing">
            <span i18n="@@settings.sku-upload.csv-sku-missing-error">SKU code is missing</span>
          </div>
        </li>
        <li *ngIf="riPositiveValueChecker > 0 && !showcsvError && !csvTemplateError">
          <div class="text-danger" id="repairabilityIndexPsitiveNum">
            <span
              i18n="@@settings.sku-upload.csv-repairability-positive-error.repairability-index-should-be-a-positive-number">Repairability
              Index should be a positive number</span>
          </div>
        </li>
        <li *ngIf="isBatteryLifeError && !showcsvError && !csvTemplateError">
          <div class="text-danger" id="batteryLifeText"><span i18n="@@upload-sku-csv.desc.battery-life-greater-than-zero">Battery life should be greater than zero</span></div>
        </li>
        <li *ngIf="riRangeErrorChecker > 0 && !showcsvError && !csvTemplateError">
          <div class="text-danger" id="repairabilityIndexgreater0">
            <span
              i18n="@@settings.sku-upload.csv-repairability-length-error.repairability-index-should-be-always-greater-than-0-and-less-than-or-equal-to-10">Repairability
              Index should always be greater than 0 and less than or equal to 10</span>
          </div>
        </li>
        <li *ngIf="isSkuCodeDuplicateError && !showcsvError && !csvTemplateError">
          <div class="text-danger" id="skuCodeDuplicate">
            <span i18n="@@settings.sku-upload.csv-sku-duplicate-error">SKU code is duplicate in uploaded CSV</span>
          </div>
        </li>
        <li
          *ngIf="emptyDeviceSkuList?.length && !showcsvError && !csvTemplateError && !isSkuCodeAvailableError && !isSkuCodeDuplicateError">
          <div class="text-danger" id="skuIdMisingComparison">
            <span i18n="@@upload-sku-csv.sku-id-missing-comparison">Device Name is missing for SKU IDs,
              {{emptyDeviceSkuList}}. Device comparison will be suppressed for these SKUs.</span>
          </div>
        </li>
        <li
        *ngIf="emptyPrimaryPriceList?.length && !showcsvError && !csvTemplateError && !isSkuCodeAvailableError && !isSkuCodeDuplicateError">
        <div class="text-danger" id="emptyPrimaryPriceList">
          <span i18n="@@upload-sku-csv.desc.primatry-price-missing">Primary Price is missing for SKU IDs,
            {{emptyPrimaryPriceList}}.</span>
        </div>
      </li>
        <li
          *ngIf="emptyProcessorsList?.length && !showcsvError && !csvTemplateError && !isSkuCodeAvailableError && !isSkuCodeDuplicateError">
          <div class="text-danger" id="processorDetailsCSV">
            <span i18n="@@upload-sku-csv.processor-details-are">The Processor details are missing for SKU IDs,
              {{emptyProcessorsList}}. Device comparison will be suppressed for these SKUs.</span>
          </div>
        </li>
        <li
          *ngIf="unMatchedProcessorList?.length && !showcsvError && !csvTemplateError && !isSkuCodeAvailableError && !isSkuCodeDuplicateError">
          <div class="text-danger" id="processorIsEither">
            <span i18n="@@upload-sku-csv.processor-is-either">The Processor is either non-Intel or an incorrect value was entered for SKU IDs,
              {{unMatchedProcessorList}}. Device comparison will be suppressed for these SKUs.</span>
          </div>
        </li>
      </ul>
    </div>
  </div>
  <div class="container" id="container">
    <div class="modal-dialog-centered" *ngIf="successPopUp" id="modalDialog">
      <div class="modal-backdrop show" id="modalBackdrop"></div>
      <div class="modal" id="myModal">
        <div class="modal-dialog" id="myModalDialog">
          <div class="modal-content" id="myModalContent">
            <div _ngcontent-fjy-c198="" class="close" (click)="closeModal()" id="myModalClose"><img _ngcontent-fjy-c198="" alt="close"
                class="modal-close-icon"></div>
            <div class="modal-body" id="myModalBody">
              <div class="text-center" id="myModalTxtCenter">
                <span class="success-img"></span>
              </div>
              <div class="action-success-msg" id="myModalActionSuccesMsg">
                <span i18n="@@upload-sku-csv.title.csv-uploaded-acknow">CSV Uploaded</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>